import { actionTypes } from "constants/Reports/harvest/fieldScaning/harvestByArea";

const initialState = {
  tableData: {
    content: [],
    isFetching: false
  },
  listData: {
    content: [],
    isFetching: false
  },
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_HARVEST_BY_AREA_TABLE_DATA_START:
      return {
        ...state,
        tableData: {
          ...state.tableData,
          isFetching: true
        }
      };
    case actionTypes.SET_HARVEST_BY_AREA_TABLE_DATA:
      return {
        ...state,
        tableData: {
          ...action.tableData,
          isFetching: false
        }
      };
    case actionTypes.FETCH_HARVEST_BY_AREA_TABLE_DATA_FAILED:
      return {
        ...state,
        tableData: {
          ...state.tableData,
          isFetching: false
        },
        error: action.error
      };
    case actionTypes.FETCH_HARVEST_BY_AREA_TABLE_LIST_START:
      return {
        ...state,
        listData: {
          ...state.listData,
          isFetching: true
        }
      };
    case actionTypes.SET_HARVEST_BY_AREA_TABLE_LIST:
      return {
        ...state,
        listData: {
          ...action.payload,
          isFetching: false
        }
      };
    case actionTypes.FETCH_HARVEST_BY_AREA_TABLE_LIST_FAILED:
      return {
        ...state,
        listData: {
          ...state.listData,
          isFetching: false
        },
        error: action.error
      };
    default:
      return state;
  }
};
